import { Button } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import ItemRows from "../components/ItemRows";
import ItemInfo from "../components/ItemInfo/ItemInfo";
import CreateItem from "../components/ItemInfo/CreateItem";
import "../ui/products.css";
import "../index.css";
import "../ui/itemrows.css";
import { useState } from "react";

const getItemIdFromQuery = (search) => {
  const params = new URLSearchParams(search);
  return params.get("item_id");
};

const Items = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const selectedItemId = getItemIdFromQuery(location.search);

  const [showCreate, setShowCreate] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [search, setSearch] = useState("");

  const handleSelectItem = (itemId) => {
    navigate(`?item_id=${itemId}`);
  };

  const handleCreated = () => {
    setShowCreate(false);
    setRefreshKey((k) => k + 1);
    toast.success("Item created!");
  };

  const handleError = (msg) => {
    toast.error(msg || "An error occurred.");
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "calc(100vh - 60px)", // subtract navbar height
        overflow: "hidden",
        background: "#f4f5f7",
      }}
    >
      {/* main horizontal flex container */}
      <div
        style={{
          display: "flex",
          flex: 1,
          minHeight: 0,
          overflow: "hidden",
        }}
      >
        {/* left pane */}
        <div
          style={{
            width: "32%",
            minWidth: 320,
            maxWidth: 420,
            display: "flex",
            flexDirection: "column",
            borderRight: "1px solid #eee",
            background: "#fafbfc",
            boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
            borderRadius: "8px 0 0 8px",
            marginRight: 8,
            minHeight: 0,
            overflow: "hidden",
          }}
        >
          {/* header */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "18px 20px 12px 20px",
              background: "#fff",
              borderBottom: "1px solid #e4e7ec",
              position: "sticky",
              top: 0,
              zIndex: 2,
            }}
          >
            <h5 style={{ margin: 0, fontWeight: 600, color: "#222" }}>Items</h5>
            <Button variant="primary" size="sm" onClick={() => setShowCreate(true)}>
              + Add Item
            </Button>
          </div>

          {/* search */}
          <div style={{ padding: "12px 20px 0 20px", background: "#fafbfc" }}>
            <input
              type="text"
              className="form-control"
              placeholder="Search items..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{ fontSize: 14, borderRadius: 6, border: "1px solid #e4e7ec" }}
            />
          </div>

          <div style={{ borderTop: "1px solid #e4e7ec", margin: "12px 0 0 0" }} />

          {/* scrollable items list */}
          <div
            style={{
              flex: 1,
              minHeight: 0,
              overflowY: "auto",
            }}
          >
            <ItemRows
              key={refreshKey}
              onSelectItem={handleSelectItem}
              selectedItemId={selectedItemId}
              search={search}
            />
          </div>
        </div>

        {/* right pane */}
        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            background: "#fff",
            borderRadius: "0 8px 8px 0",
            boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
            minHeight: 0,
            overflow: "hidden",
          }}
        >
          {/* scrollable detail area */}
          <div
            style={{
              flex: 1,
              minHeight: 0,
              overflowY: "auto",
              padding: "18px 20px",
            }}
          >
            {selectedItemId ? (
              <ItemInfo
                itemId={selectedItemId}
                onError={handleError}
                onSuccess={(msg) => toast.success(msg)}
              />
            ) : (
              <h4
                style={{
                  color: "#888",
                  marginTop: 80,
                  marginBottom: 0,
                  textAlign: "center",
                }}
              >
                Select an item to view details
              </h4>
            )}
          </div>
        </div>
      </div>

      {/* create modal */}
      <CreateItem
        show={showCreate}
        onHide={() => setShowCreate(false)}
        onCreated={handleCreated}
        onError={handleError}
      />

      {/* toast notifications */}
      <Toaster
        toastOptions={{
          className: "",
          style: {
            borderRadius: "10px",
            background: "#333",
            color: "#fff",
          },
          position: "bottom-center",
        }}
      />
    </div>
  );
};

export default Items;